import { useEffect, useRef, useState } from "react";
import { changeRoute } from "./pageTransition";

/** Routes keep the previous site's hash URLs, so old links still work. */
export type Route =
  | { page: "home"; section?: string }
  | { page: "project"; id: string }
  | { page: "experience"; slug: string }
  | { page: "guide"; id: string };

export function parseHash(hash: string): Route {
  const [first, second] = hash.replace(/^#\/?/, "").split("/");
  if (first === "work" && second) return { page: "project", id: second };
  if (first === "experience" && second) return { page: "experience", slug: second };
  if (first === "build" && second) return { page: "guide", id: second };
  return { page: "home", section: first || undefined };
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseHash(window.location.hash));
  const current = useRef(route);
  useEffect(() => {
    const onChange = () => {
      const next = parseHash(window.location.hash);
      const from = current.current;
      current.current = next;
      changeRoute(from, next, () => setRoute(next));
    };
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return route;
}
